import { UserGroupValues } from './types';

export const USER_GROUP_VALUES: UserGroupValues = {
 name:null,
  description: null,
  _rowTimestamp:null,
  isAccessOnlyToCreatedRows:null,
};
